export const funnelReportsRunIdAppGroupIdStatus = "/funnel_reports/:run_id/:app_group_id/status";
